module.exports = __webpack_public_path__ + "img/logo-mo-35.5c190bdd.svg";